<template>
  <div class="container">
    <div class="row justify-content-end mt-2">
      <!-- <div class="col-4"> -->
      <a href="/login" class="custom-button">
        <div class="custom-button-icon">
          <i class="fas fa-user"></i>
        </div>
        <div class="custom-button-text">
          XtrimPro <small>Iniciar sesión</small>
        </div>
      </a>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "Ingresar-Landing",
  components: {},

  data() {
    return {
      loading: true,
      isMobile: this.$isMobile,
    };
  },
  computed: {},
  watch: {},

  activated() {},
  mounted() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
  methods: {},
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 0;
}

.row {
  margin: 0;
}

.custom-button {
  display: flex;
  align-items: center;
  background-color: white;
  border: 3px solid #ffd700;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-right: none;
  padding: 8px 15px 8px 8px;
  color: white;
  font-family: Arial, sans-serif;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.2s ease;
}

.custom-button:hover {
  transform: scale(1.05);
}

.custom-button-icon {
  background-color: #800080;
  color: white;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  flex-shrink: 0;
}

.custom-button-text {
  color: #800080;
  font-size: 12px;
  white-space: nowrap;
}

.custom-button-text small {
  display: block;
  font-size: 11px;
  color: #800080;
  font-weight: normal;
}

/* Media queries para pantallas muy pequeñas */
@media (max-width: 360px) {
  .custom-button {
    padding: 6px 12px;
  }

  .custom-button-icon {
    width: 30px;
    height: 30px;
    margin-right: 6px;
  }

  .custom-button-text {
    font-size: 11px;
  }

  .custom-button-text small {
    font-size: 9px;
  }
}
</style>
